/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Purchase_1Inputs */

const en_flow_purchase_1 = /** @type {(inputs: Flow_Purchase_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow issues the purchase order in Backstage.`)
};

/**
* | output |
* | --- |
* | "Tomorrow issues the purchase order in Backstage." |
*
* @param {Flow_Purchase_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_purchase_1 = /** @type {((inputs?: Flow_Purchase_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Purchase_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_purchase_1(inputs)
});